export const messages = {
    "en": {
        "yes": "Yes",
        "no": "No",
        "more": "More",
        "create": "Create",
        "create_new": "Create new",
        "duplicate": "Duplicate",
        "update": "Edit",
        "delete": "Delete",
        "cancel": "Abort",
        "active": "Active",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "save": "Save",
        "save_finally": "Give binding",
        "upload": "Upload",
        "download": "Download",
        "media": "Media",
        "files": "Files",
        "internalfiles": "Internal files",
        "prev_page": "Previous page",
        "next_page": "Next page",
        "actions": "Actions",
        "till": "till",
        "search": "Search",
        "search.empty": "No search results available.",
        "qm": "qm",
        "qm_total": "qm total area",
        "cm": "cm",
        "m": "m",
        "status": "Status",
        "week": "KW %{week}",
        "createdon_date": "Created date",
        "modifiedon_date": "Edited date",
        "phone": "Tel.",
        "mail": "Mail",
        "gender_0": "Male",
        "gender_1": "Female",
        "gender_2": "Other",
        "layer_toggle": "Toggle layer",
        "results_loading": "Retrieving data...",
        "no_results_found": "No results found.",
        "select_all": "Select all",
        "select": "Make a selection",
        "filter_show_all": "Show deactivated",
        "active.active_0": "No",
        "active.active_1": "Yes",
        "date.on": "at",

        "nav.logo": "AS Asphaltbau Auftragssystem",
        "nav.overview": "Overview",
        "nav.customers": "Customers",
        "nav.projects": "Projects",
        "nav.notifications": "Notifications",
        "nav.account": "Profile",
        "nav.login": "Login",
        "nav.logout": "Logout",
        "nav.tours": "Tourplan",
        "nav.weeks": "Weekly Planner",
        "nav.projectmap": "Project Map",
        "nav.projectplanningexport": "KI MVP",
        "companyname": "Company Name",
        "address": "Address",

        "table.page.prev": "<",
        "table.page.next": ">",
        "table.page.first": "<<",
        "table.page.last": ">>",

        "status.open": "Open",
        "status.open_short": "Open",
        "status.busy": "Busy",
        "status.busy_short": "Busy",
        "status.pending": "Pending",
        "status.pending_short": "Pending",
        "status.finished": "Finished",
        "status.finished_short": "Finished",
        "status.finished_manual": "Finished",
        "status.finished_manual_short": "Finished",
        "status.cancelled": "Cancelled",
        "status.cancelled_short": "Cancelled",
        "status.notcancelled": "not Cancelled",
        "status.open_busy_notscheduled": "Open, busy, und not yet scheduled",

        "placementtype.1": "Street",
        "placementtype.2": "Sidewalk",

        "search.term": "Search term",
        "search.project_number": "Project number",
        "search.from": "from",
        "search.till": "till",
        "search.pm": "Project manager",
        "search.status": "Status",
        "search.location": "Location",

        "form.error_form": "One or more fields have not been entered correctly.",
        "form.error_form.projectcrud": "One or more fields have not been entered correctly. Please make sure that the square meters are in whole numbers.",
        "form.submit": "Submit",
        "form.submit.save": "Save",
        "form.submit.insert": "Insert",
        "form.submit.confirm": "Confirm",
        "form.username": "Username",
        "form.password": "Password",
        "form.password_confirm": "Password (again)",
        "form.email": "Emailaddress",
        "form.email.plc": "max.mustermann@domain.de",
        "form.address1": "Address",
        "form.address1.plc": "Musterstraße 17",
        "form.address2": "Address 2",
        "form.address2.plc": "Stockwerk o.ä.",
        "form.zipcode": "Zipcode",
        "form.zipcode.plc": "",
        "form.zipcode.choose": "Choose your zipcode",
        "form.city": "City",
        "form.city.plc": "Musterstadt",
        "form.city.choose": "Choose your city",
        "form.street": "Street",
        "form.street.plc": "Street",
        "form.housenumber": "Nr.",
        "form.housenumber.plc": "Nr.",
        "form.phone": "Phone number",
        "form.fax": "Fax number",
        "form.phone.plc": "",
        "form.mobile": "Mobile number",
        "form.mobile.plc": "",
        "marker": "Marker",

        "form.upload.create.title": "Upload a file",
        "form.upload.create.success": "File successfully uploaded.",
        "form.upload.update.title": "Update file",
        "form.upload.update.success": "File successfully updated.",
        "form.upload.file": "File",
        "form.upload.file.plc": "Please select a file.",
        "form.upload.comment": "Comment",
        "form.upload.comment.plc": "Here you can leave a comment.",
        "form.upload.create": "Upload",
        "form.upload.update": "Update",

        "notifications.no_results_found": "No notifications available.",

        /* Home lexicons */

        "home.title": "Dashboard",
        "home.subtitle": "%{user.firstname} %{user.lastname}", //%{account.last_login}", // TODO implement something like Last Login here

        "home.notifications.title": "Notifications",
        "home.notifications.project_create": "New project",
        "home.notifications.project_create.desc": "%{project_number} created by customer %{company}",
        "home.notifications.project_update": "Project updated",
        "home.notifications.project_update.desc": "%{project_number} updated by customer %{company}",

        "home.projects.view": "View projects",
        "home.projects.title": "Projects",
        "home.projects.label": "Project per week",
        "home.projects.yesterday": "New projects yesterday",
        "home.projects.week": "New projects this week",
        "home.projects.month": "New projects this month",
        "home.projects.total": "active projects",

        "home.quicklinks.title": "Quicklinks",
        "home.quicklinks.create_project": "Create project",
        "home.quicklinks.create_client": "Create client",

        "home.quicklinks2.title": "Quicklinks",
        "home.quicklinks2.manage_users": "Manage users",
        "home.upload-risk": "Upload Risk number Excel",

        /* Project lexicons */

        "projects": "Projects",
        "projects.title": "Projects",
        "project": "Project",
        "project.view.title": "Project",
        "project.create.title": "Create new project",
        "project.create.success": "Project successfully created.",
        "project.update.title": "Update project",
        "project.update.success": "Project successfully updated.",
        "project.active": "Are you sure you want to activate this project?",
        "project.active.success": "Customer admin successfully activated.",
        "project.deactive": "Are you sure you want to deactivate this project?",
        "project.deactive.success": "Customer admin successfully deactivated.",
        "project.create_quick.title": "Create project",
        "project.activate.button": "Restore",
        "project.deactivate.button": "Cancel",

        "projects.qm.total": "Total open square meters:",
        "form.project.duplicate.message": "You are duplicating a project",
        "form.project.title.project": "Project",
        "form.project.title.location": "Construction site",
        "form.project.title.default_layers": "Execution asphalting",
        "form.project.title.addition_layers": "Additional construction",
        "form.project.title.addition_layers.total": "Additional",
        "form.project.location": "Location",
        "form.project.location.plc": "Select a location",
        "form.project.pm": "Project manager",
        "form.project.pm.plc": "Select a project manager",
        "form.project.project_number": "Project number",
        "form.project.site_comments": "Comment",
        "form.project.site_comments.plc": "Enter comment on the construction site location here",
        "form.project.site_contact_info": "Contact details",
        "form.project.site_contact_info.plc": "Contact details local contact person (name, first name, mobile phone number)",
        "form.project.internal_number": "Internal project number",
        "form.project.internal_number.plc": "Internal project or cost center number",
        "form.project.requested_deadline": "Preferred date",
        "form.project.requested_deadline.plc": "YYYY/MM/DD or weeknumber",
        "form.project.layer_hole": "FEMALE HOLE",
        "form.project.layer_tok": "TOK",
        "form.project.layer_installation": "INSTALLATION BY FINISHER (Minimum width 1.0 m)",
        "form.project.layer_width": "INSTALLATION WIDTH in m",
        "form.project.layer.placement_type": "Placement typ",
        "form.project.layer.placement_type.plc": "Select a placement typ",
        "form.project.layer.subtype": "Sub type",
        "form.project.layer.subtype.plc": "Select a sub type",
        "form.project.layer.area": "Area",
        "form.project.layer.area.plc": "Area (qm)",
        "form.project.layer.thickness": "Thickness",
        "form.project.layer.thickness.plc": "Thickness (cm)",
        "form.project.layer.log.area.plc": "Done qm",
        "form.project.layer.log.comment.plc": "Please specify a reason here",
        "form.project.layer.finish.title": "You want to mark %{layer} as finished",
        "form.project.layer.finish.content": "%{total} qm should be executed, only %{finished} qm are entered. Why?",
        "form.project.maps.no_valid_address": "Please enter a valid address.",
        "form.project.maps.no_valid_location": "No results found for \"%{address}\".",

        /* Page not found lexicons */

        "page_not_found": "This is the page not found controller...",

        /* Comment lexicons */

        "comments.title": "Comments",
        "comments.create_new": "Create new comment",
        "comments.no_results_found": "There is no comment posted yet.",

        "form.comments.comment": "Comment",
        "form.comments.comment.plc": "Type your comment or message here.",

        /* Media Lexicons */

        "media.title": "Media",
        "media.description": "Please upload here .pdfs or image files as .jpg to your submission. <strong>Please note the max. File size of 5 MB!</strong>",
        "media.selected_files": "Selected files",

        /* Account lexicons */

        "login.forgot_password": "Forgot password",

        "form.login.submit": "Sign in",
        "form.login.error_form": "One or more fields have not been entered correctly.",
        "form.login.error_login": "No user was found with the specified email address and password.",

        "form.forgot_password.submit": "Send password",
        "form.forgot_password.error_form": "One or more fields have not been entered correctly.",
        "form.forgot_password.error_password": "No user was found with the specified email address.",
        "form.forgot_password.success": "You have received an email with a link to reset your password.",

        "account.profile": "Profile",
        "account.profile.description": "Profile description",
        "account.profile.update": "Edit profile",
        "account.profile.update.success": "Profile successfully updated.",
        "account.profile.password.update": "Edit password",
        "account.profile.password.update.success": "Password successfully updated.",
        "account.profile.password.reset": "Reset password",
        "account.profile.password.reset.success": "Password successfully resetted.",
        "account.profile.email": "E-mailaddress",
        "account.profile.email.update": "Edit e-mailaddress",
        "account.profile.email.update.success": "You have received an email with a link to confirm your e-mailaddress.",
        "account.profile.email.confirm": "Confirm e-mailadress",
        "account.profile.email.confirm.success": "Your e-mailaddress is successfully updated.",
        "account.view": "View user",
        "account.create": "Create user",
        "account.create.success": "User successfully created",
        "account.update": "Update user",
        "account.update.success": "User successfully updated",
        "account.message.none_yet": "not yet",
        "account.accepted.dsvgo_consent": "DSVGO Consent given",

        "form.account.salutation": "Salutation",
        "form.account.salutation.plc": "",
        "form.account.title": "Title",
        "form.account.title.plc": "",
        "form.account.firstname": "First name",
        "form.account.firstname.plc": "",
        "form.account.lastname": "Last name",
        "form.account.lastname.plc": "",
        "form.account.gender": "Gender",
        "form.account.gender.plc": "",
        "form.account.email": "Emailaddress",
        "form.account.change_email": "I want to change my emailaddress",
        "form.account.email.plc": "",
        "form.account.city": "City",
        "form.account.city.plc": "",
        "form.account.housenumber": "Housenumber",
        "form.account.housenumber.plc": "",
        "form.account.region": "Region",
        "form.account.region.plc": "",
        "form.account.street": "Street",
        "form.account.street.plc": "",
        "form.account.zipcode": "Zipcode",
        "form.account.zipcode.plc": "",
        "form.account.position": "Position",
        "form.account.position.plc": "",
        "form.account.active": "Active",
        "form.account.permissions": "Permissions",
        "form.account.permissions.plc": "",
        "form.account.permissions.read": "Read",
        "form.account.permissions.write": "Write",
        "form.account.permissions.read_write": "Read and Write",

        /* Location lexicons */

        "locations": "Locations",
        "locations.title": "Locations",
        "location": "Location",
        "location.view.title": "Location",
        "location.create.title": "Create location",
        "location.create.success": "Location successfully created.",
        "location.update.title": "Update location",
        "location.update.success": "Location successfully updated.",
        "location.active.title": "Are you sure you want to activate this location?",
        "location.active.success": "Location successfully activated.",
        "location.deactive.title": "Are you sure you want to deactivate this location?",
        "location.deactive.success": "Location successfully deactivated.",
        "location.risk.risk_number": "Risk number",
        "location.risk.decided_budget": "Decided limit",
        "location.risk.decided_budget.not_exist": "No limit defined",
        "location.risk.limit": "Limit",
        "location.risk.valid_from": "Valid from",
        "location.risk.valid_until": "Valid until",
        "location.risk.not_valid": "The limit is no longer valid",
        "location.risk.no_risk_number": "Location has no risk number",
        "location.risk.some.locations.without.risk": "Some locations do not have a risk no.",

        /* Project managers lexicons */

        "pms": "Project managers",
        "pms.title": "Project managers",
        "pm": "Project manager",
        "pm.view.title": "Project manager",
        "pm.create.title": "Create project manager",
        "pm.create.success": "Project manager successfully created.",
        "pm.update.title": "Update project manager",
        "pm.update.success": "Project manager successfully updated.",
        "pm.active.title": "Are you sure you want to activate this project manager?",
        "pm.active.success": "Project manager successfully activated.",
        "pm.deactive.title": "Are you sure you want to deactivate this project manager?",
        "pm.deactive.success": "Project manager successfully deactivated.",

        /* Customer admins lexicons */

        "admins": "Customer admins",
        "admins.title": "Customer admins",
        "admin": "Customer admin",
        "admin.view.title": "Customer admin",
        "admin.create.title": "Create new customer admin",
        "admin.create.success": "Customer admin successfully created.",
        "admin.update.title": "Update new customer admin",
        "admin.update.success": "Customer admin successfully updated.",
        "admin.active.title": "Are you sure you want to activate this customer admin?",
        "admin.active.success": "Customer admin successfully activated.",
        "admin.deactive.title": "Are you sure you want to deactivate this customer admin?",
        "admin.deactive.success": "Customer admin successfully deactivated.",

        "customers": "Customers",
        "customers.title": "All customers",
        "customers.list": "Customers",
        "customers.search_customer": "Customer search",
        "customers.create": "Create customer",
        "customers.update": "Update customer",
        "customers.list.empty": "No customers found",
        "customers.overview": "Overview",
        "customers.projects_open": "Open projects",
        "customers.projects_partly_done": "Partly completed projects",
        "customers.info": "Information",
        "customers.client_number": "Client number",
        "customers.location_number": "Location number",
        "customers.location_number.plc": "",
        "customers.project_number": "Project number",
        "customers.project_number_required": "Project or cost number entry field is required",
        "customers.company_name": "Company name",
        "customers.contact_person": "Contact person",
        "customers.country": "Country",
        "customers.pm.mobile": "Mobile number",
        "customers.hq_location": "Headquarter location",

        "form.customers.save.success": "The customer is successfully saved.",

        "form.customer.title.customer": "Client",
        "form.customer.title.hq_location": "Headquarter",

        "customer.customer.view.title": "Client",
        "customer.customer.create.title": "Create new client",
        "customer.customer.create.success": "Client successfully created.",
        "customer.customer.update.title": "Update client",
        "customer.customer.update.success": "Client successfully updated.",
        "customer.customer.active": "Are you sure you want to activate this client?",
        "customer.customer.active.success": "Client successfully activated.",
        "customer.customer.deactive": "Are you sure you want to deactivate this client?",
        "customer.customer.deactive.success": "Client successfully deactivated.",

        /* Exceptions */

        "exceptions.uploads.file_already_exists": "The file already exists.",
        "exceptions.uploads.extension_not_allowed": "The file extension is not allowed.",
        "exceptions.uploads.file_too_big": "The file is too big.",
        "exceptions.uploads.upload_failed": "An unknown error has occurred.",

        /* Account Names */
        "account.admin ": "Admin",
        "account.pm": "Project Manager",
        "account.clientadmin": "Client Admin",
        "account.client": "Client",

        /* Tours */
        "tours.title": "Tourplan Overview",
        "tours.tournumber": "Tourplan Number",
        "tours.kolonne": "Kolonne",
        "tours.from": "von",
        "tours.till": "bis",
        "tours.companyname": "Firmenname",

        /* Weekday planner */
        'weeks.project.milling': 'Milling',
        'weeks.project.milling.comment': 'Bring Hilti + power generator!!!',
        'weeks.project.is_date_fixed': 'Date fixed',

        /* Mixing plants */
        'mixingplants.title': 'Mixing Plants',
        'mixingplants.list.button.title': 'Edit Mixing Plants',
        'mixingplants.title.search': 'Mixing Plants Search',
        'mixingplants.ranking.label': 'Rating',
        "mixingplants.create.success": "Successfully created mixing plant.",
        "mixingplants.update.success": "Successfully updated mixing plant.",
        "mixingplant.search.title": "Search Mixing Plants",
        "mixingplant.search.add": "Add mixing plant",
        "mixingplant.search.error.no_address": "Failed to find address for zipcode %{zipcode}\n",
        
        /* Internal area */
        "project.internal_note": "Note",
        "project.internalarea.title": "Internal Project Information",
        
        /* Internal files */
        "internalfiles.dropfileshere": "Drop your files here",
        "internalfiles.button.export": "Export files",
        "internalfiles.button.download": "Download Zip file",
        "internalfiles.releasefileshere": "Release to drop files here",
        "internalfiles.clicktoupload": "Click here to start uploading",
        "internalfiles.description": "Please upload here .pdfs or image files as .jpg to your submission. <strong>Please note the max. File size of 10 MB!</strong>",
    },
    "de": {
        "yes": "Ja",
        "no": "Nein",
        "date": "Datum",
        "more": "Mehr",
        "create": "Erstellen",
        "create_new": "Neu anlegen",
        "duplicate": "Duplizieren",
        "update": "Bearbeiten",
        "delete": "Löschen",
        "generatepdf": "PDF Generieren",
        "cancel": "Abbrechen",
        "active": "Aktiv",
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren",
        "save": "Speichern",
        "save_finally": "Verbindlich erteilen",
        "upload": "Upload",
        "download": "Herunterladen",
        "media": "Dateiverwaltung",
        "files": "Dateiverwaltung",
        "internalfiles": "Interne Datei",
        "prev_page": "Vorherige Seite",
        "next_page": "Nächste Seite",
        "actions": "Aktionen",
        "till": "bis",
        "search": "Suchen",
        "search.empty": "Keine Suchergebnisse verfügbar.",
        "qm": "qm",
        "qm_total": "qm Fläche gesamt",
        "cm": "cm",
        "m": "m",
        "tons": "Tonnen",
        "insert": "Hinzufügen",
        "status": "Status",
        "week": "KW %{week}",
        "createdon_date": "Erstellungsdatum",
        "modifiedon_date": "Änderungsdatum",
        "phone": "Tel.",
        "mail": "E-Mail",
        "mobile": "Mobil",
        "gender_0": "Mann",
        "gender_1": "Frau",
        "gender_2": "Divers",
        "layer_toggle": "Decke umschalten",
        "results_loading": "Daten abrufen...",
        "no_results_found": "Keine Daten verfügbar.",
        "select_all": "Alle auswählen",
        "select": "Auswahl treffen",
        "filter_show_all": "Deaktivierte anzeigen",
        "active.active_0": "Nein",
        "active.active_1": "Ja",
        "sum.openqm": "Summe offene QM",
        "personnel": "Personal",
        "forward": "Vorne",
        "backward": "Zurück",
        "pdf.download.button.label": "PDF Downloads",
        "date.on": "am",
        "nav.logo": "AS Asphaltbau Auftragssystem",
        "nav.overview": "Übersicht",
        "nav.customers": "Kunden",
        "nav.projects": "Aufträge",
        "nav.notifications": "Benachrichtigungen",
        "nav.account": "Profil",
        "nav.login": "Einloggen",
        "nav.logout": "Ausloggen",
        "nav.tours": "Tourenplan",
        "nav.weeks": "Wochenplan",
        "nav.projectmap": "Auftragskarte",
        "nav.projectplanningexport": "KI MVP",
        "companyname": "Firmenname",
        "address": "Anschrift",

        "table.page.prev": "←",
        "table.page.next": "→",
        "table.page.first": "⇤",
        "table.page.last": "⇥",

        "status.open": "Offen",
        "status.open_short": "Offen",
        "status.busy": "Teilerledigt",
        "status.busy_short": "Teilerl.",
        "status.open_busy": "Offen und Teilerledigt",
        "status.pending": "In Ausführung",
        "status.pending_short": "In Ausf.",
        "status.finished": "Erledigt",
        "status.finished_short": "Erledigt",
        "status.finished_manual": "Erledigt",
        "status.finished_manual_short": "Erledigt",
        "status.cancelled": "Storniert",
        "status.cancelled_short": "Storniert",
        "status.notcancelled": "Auftragsbestand",
        "status.open_busy_notscheduled": "Offen, Teilerledigt, u. nicht eingeplant",

        "placementtype.1": "Straße",
        "placementtype.2": "Gehweg",

        "search.term": "Suchbegriff",
        "search.project_number": "Auftragsnummer",
        "search.from": "von",
        "search.till": "bis",
        "search.pm": "Bauleiter",
        "search.status": "Status",
        "search.location": "Niederlassung",
        "search.project.title": "Auftragsuche",
        "search.project.intro": "Suchen Sie hier nach Auftragsnummer.",

        "form.error_form": "Ein oder mehrere Felder wurden nicht korrekt eingegeben.",
        "form.error_form.projectcrud": "Ein oder mehrere Felder wurden nicht korrekt eingegeben. Bitte achten Sie darauf, dass die Quadratmeter in ganzen Zahlen angegeben werden.",
        "form.error_form.nosquaremeters": "Für Ihren Eintrag müssen Quadratmeter eingegeben werden.",
        "form.submit": "Einreichen",
        "form.submit.insert": "Einfügen",
        "form.submit.save": "Speichern",
        "form.submit.confirm": "Bestätigen",
        "form.username": "Nutzername",
        "form.password": "Passwort",
        "form.password_confirm": "Passwort (nochmal)",
        "form.email": "E-Mail-Adresse",
        "form.email.plc": "max.mustermann@domain.de",
        "form.address1": "Adresse",
        "form.address1.plc": "Musterstraße 17",
        "form.address2": "Adresse 2",
        "form.address2.plc": "Stockwerk o.ä.",
        "form.zipcode": "PLZ",
        "form.zipcode.plc": "Postleitzahl",
        "form.distance.km": "Umkreis in km",
        "form.zipcode.choose": "Wählen Sie Ihre Postleitzahl",
        "form.city": "Ort",
        "form.city.plc": "Musterstadt",
        "form.city.choose": "Wählen Sie Ihren Ort",
        "form.street": "Straße",
        "form.street.plc": "Straße",
        "form.housenumber": "Nr.",
        "form.housenumber.plc": "Nr.",
        "form.phone": "Telefonnummer",
        "form.fax": "Faxnummer",
        "form.phone.plc": "0123 987 654 43",
        "form.mobile": "Handynummer",
        "form.mobile.plc": "",
        "form.upload.create.title": "Eine Datei hochladen",
        "form.upload.create.success": "Datei erfolgreich hochgeladen.",
        "form.upload.update.title": "Eine Datei bearbeiten",
        "form.upload.update.success": "Datei erfolgreich aktualisiert.",
        "form.upload.file": "Datei",
        "form.upload.file.plc": "Bitte wählen Sie eine Datei aus.",
        "form.upload.comment": "Kommentar",
        "form.upload.comment.plc": "Hier können Sie einen Kommentar hinterlassen.",
        "form.upload.create": "Hochladen",
        "form.upload.update": "Bearbeiten",
        "marker": "Marker",

        /* Units */
        "unit.km": "km",

        "notifications.no_results_found": "Keine Benachrichtigungen verfügbar.",

        /* Home lexicons */

        "home.title": "Dashboard",
        "home.subtitle": "%{user.firstname} %{user.lastname}", //%{account.last_login}", // TODO implement something like Last Login here

        "home.notifications.title": "News",
        "home.notifications.project_create": "Neuer Auftrag: %{project_number}",
        "home.notifications.project_create.desc": "%{company}",
        "home.notifications.project_update": "Bearbeiteter Auftrag: %{project_number}",
        "home.notifications.project_update.desc": "%{company}",

        "home.projects.view": "Zur Auftragsliste",
        "home.projects.title": "Auftrags-Puls",
        "home.projects.label": "Aufträge pro Woche",
        "home.projects.yesterday": "Neu gestern",
        "home.projects.week": "Neu diese Woche",
        "home.projects.month": "Letzte 4 Wochen",
        "home.projects.total": "Aktive gesamt",

        "home.quicklinks.title": "Schnellzugriff",
        "home.quicklinks.create_project": "Auftrag anlegen",
        "home.quicklinks.create_client": "Neukunde anlegen",

        "home.quicklinks2.title": "Verwaltung",
        "home.quicklinks2.manage_users": "Benutzer verwalten",
        "home.upload-risk": "Upload Risiko-Nr.",

        /* Project lexicons */

        "projects": "Aufträge",
        "projects.title": "Aufträge",
        "project": "Auftrag",
        "project.title": "Auftrag",
        "project.view.title": "Auftrag",
        "project.create.title": "Neuen Auftrag anlegen.",
        "project.create.success": "Auftrag erfolgreich erstellt.",
        "project.update.title": "Auftrag bearbeiten",
        "project.update.success": "Auftrag erfolgreich aktualisiert.",
        "project.active": "Möchten Sie diesen Auftrag wirklich wiederherstellen?",
        "project.active.success": "Auftrag erfolgreich wiederhergestellt.",
        "project.deactive": "Möchten Sie diesen Auftrag wirklich stornieren?",
        "project.deactive.success": "Auftrag erfolgreich storniert.",
        "project.create_quick.title": "Auftrag erstellen",
        "project.activate.button": "Wiederherstellen",
        "project.deactivate.button": "Stornieren",
        "project.message.onestreetperproject": "Pro Straße bitte einen separaten Auftrag anlegen.",
        "project.pdf.generate_message": "PDF für \"%{project_number}\" generieren",


        "project.error.nogeolocation": "Diesem Auftrag fehlen Geokoordinaten. Bitte überprüfen Sie die Einstellungen der Karte.",
        "projects.qm.total": "Gesamt-Quadratmeter:",
        "projects.qm.totalopen": "Offene Quadratmeter:",
        "form.project.error.checktok": "Sind Sie sicher, dass kein TOK-Band eingebaut werden soll?",
        "form.project.duplicate.message": "Sie duplizieren einen bereits bestehenden Auftrag.",
        "form.project.title.project": "Auftrag",
        "form.project.title.location": "Ort der Baustelle",
        "form.project.title.default_layers": "Ausführung Asphaltierung",
        "form.project.title.addition_layers": "Zusätzlicher Aufbau",
        "form.project.title.addition_layers.total": "Zusätzlich: <strong>%{total}</strong> qm",
        "form.project.location": "Niederlassung",
        "form.project.location.plc": "Wählen Sie eine Niederlassung",
        "form.project.pm": "Bauleiter",
        "form.project.pm.plc": "Wählen Sie einen Bauleiter",
        "form.project.project_number": "Auftragsnummer",
        "form.project.site_comments": "Kommentar",
        "form.project.site_comments.plc": "Kommentar zum Baustellen-Ort hier eingeben",
        "form.project.site_contact_info": "Kontaktdaten",
        "form.project.site_contact_label": "Ansprechpartner mit Mobilnummer",
        "form.project.site_contact_info.plc": "Kontaktdaten Ansprechpartner vor Ort (Name, Vorname, Mobilfunknummer)",
        "form.project.internal_number": "Interne Projektnummer / Kostenstelle",
        "form.project.internal_number.plc": "Interne Projekt- oder Kostenstellennummer",
        "form.project.requested_deadline": "Wunschtermin",
        "form.project.requested_deadline.plc": "TT/MM/JJJJ oder KW",
        "form.project.layer_hole": "MUFFENLOCH",
        "form.project.layer_tok": "TOK",
        "form.project.layer_installation": "EINBAU DURCH FERTIGER (Mindestbreite 1,0 m)",
        "form.project.layer_width": "EINBAUBREITE in m",
        "form.project.layer.placement_type": "Platzierung",
        "form.project.layer.placement_type.plc": "Wählen Sie eine Platzierung",
        "form.project.layer.subtype": "Untertyp",
        "form.project.layer.subtype.plc": "Wählen Sie einen Untertyp",
        "form.project.layer.area": "Fläche",
        "form.project.layer.area.plc": "Fläche (qm)",
        "form.project.layer.thickness": "Dicke",
        "form.project.layer.thickness.plc": "Dicke (cm)",
        "form.project.layer.log.area.plc": "Erledigt qm",
        "form.project.layer.log.comment.plc": "Bitte hier einen Grund angeben",
        "form.project.layer.finish.title": "Sie wollen %{layer} als erledigt markieren",
        "form.project.layer.finish.content": "%{total} qm sollten ausgeführt werden, nur %{finished} qm sind eingetragen. Warum?",
        "form.project.maps.no_valid_address": "Bitte geben Sie eine gültige Adresse ein.",
        "form.project.maps.no_valid_location": "Keine Daten verfügbar für \"%{address}\".",

        /* Page not found lexicons */

        "page_not_found": "Seite nicht gefunden...",

        /* Comment lexicons */

        "comments.title": "Kommentar",
        "comments.create_new": "Erstelle einen neuen Kommentar.",
        "comments.no_results_found": "Es ist noch kein Kommentar veröffentlicht.",

        "form.comments.comment": "Kommentar",
        "form.comments.comment.plc": "Geben Sie Ihren Kommentar oder Ihre Nachricht hier ein.",

        /* Media Lexicons */

        "media.title": "Datei",
        "media.description": "Laden Sie bitte hier PDF-Dateien oder Bilddateien (jpg) zu Ihrem Teilauftrag hoch.<br/><strong>Bitte beachten Sie die max. Dateigröße von 5 MB!</strong>",

        "media.selected_files": "Ausgewählte Dateien",

        /* Account lexicons */

        "form.message.edit.adminaccount": "Bitte beachten Sie: Sie bearbeiten einen Administrator.",
        "login.forgot_password": "Zugangsdaten vergessen?",

        "form.login.submit": "Anmelden",
        "form.login.error_form": "Eines oder mehrere Felder wurden nicht korrekt eingegeben.",
        "form.login.error_login": "Es wurde kein Benutzer mit der angegebenen E-Mail-Adresse und dem angegebenen Passwort gefunden.",

        "form.forgot_password.submit": "Passwort neu erstellen",
        "form.forgot_password.error_form": "Eines oder mehrere Felder wurden nicht korrekt eingegeben.",
        "form.forgot_password.error_password": "Es wurde kein Benutzer mit der angegebenen E-Mail-Adresse gefunden.",
        "form.forgot_password.success": "Sie haben eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts erhalten.",

        "account.profile": "Profil",
        "account.profile.description": "Profil-Beschreibung",
        "account.profile.update": "Mein Profil bearbeiten",
        "account.profile.update.success": "Profil erfolgreich aktualisiert.",
        "account.profile.password.update": "Passwort bearbeiten",
        "account.profile.password.update.success": "Passwort erfolgreich aktualisiert.",
        "account.profile.password.reset": "Passwort zurücksetzen",
        "account.profile.password.reset.success": "Passwort erfolgreich zurückgesetzt.",
        "account.profile.email": "E-Mail-Adresse",
        "account.profile.email.update": "E-Mail-Adresse ändern",
        "account.profile.email.update.success": "Sie haben eine E-Mail mit einem Link zur Bestätigung Ihrer E-Mail-Adresse erhalten.",
        "account.profile.email.confirm": "Änderung Ihrer E-Mail-Adresse",
        "account.profile.email.confirm.success": "Ihre E-Mail-Adresse wurde erfolgreich aktualisiert. Sie können sich nun mit der neuen Adresse im System anmelden.",
        "account.view": "Benutzer anzeigen",
        "account.create": "Benutzer anlegen",
        "account.create.success": "Benutzer erfolgreich erstellt",
        "account.update": "Benutzer bearbeiten",
        "account.update.success": "Benutzer erfolgreich aktualisiert",
        "account.message.none_yet": "noch keinen",
        "account.accepted.dsvgo_consent": "DSVGO Consent gegeben",

        "account.project.email_notification_on_update_title": "Benachrichtigung bei Auftragsänderung",
        "account.project.email_notification_on_update_description": "Wenn aktiviert: es wird eine Email-Benachrichtigung an diese Person geschickt, sobald ein Auftrag geändert wird, welches bereits in einer Tour geplant und einer Kolonne zugewiesen ist.",

        "form.account.activity_tracking.title": "Nachvollziehbarkeit von Aktivitäten",
        "form.account.activity_tracking.description": "Wir haben eine neue Option zur Nachvollziehbarkeit von Aktivitäten hinzugefügt. Diese Nachvollziehbarkeit ist nötig um Änderungen an Projekten zu verstehen. Bspw.: welche Person hat zu welcher Zeit Änderungen an einem Projekt vorgenommen.",
        "form.account.activity_tracking.agreed": "Einverstanden: ich stimme dem Speichern von Aktivitäten für die Nachvollziehbarkeit zu",
        "form.account.salutation": "Anrede",
        "form.account.salutation.plc": "",
        "form.account.title": "Titel",
        "form.account.title.plc": "",
        "form.account.firstname": "Vorname",
        "form.account.firstname.plc": "",
        "form.account.lastname": "Nachname",
        "form.account.lastname.plc": "",
        "form.account.gender": "Geschlecht",
        "form.account.gender.plc": "",
        "form.account.email": "E-Mail-Adresse",
        "form.account.change_email": "Ich möchte meine E-Mail-Adresse ändern",
        "form.account.email.plc": "",
        "form.account.city": "Stadt",
        "form.account.city.plc": "",
        "form.account.housenumber": "Hausnummer",
        "form.account.housenumber.plc": "",
        "form.account.region": "Region",
        "form.account.region.plc": "",
        "form.account.street": "Straße",
        "form.account.street.plc": "",
        "form.account.zipcode": "Postleitzahl",
        "form.account.zipcode.plc": "",
        "form.account.position": "Funktion",
        "form.account.position.plc": "",
        "form.account.active": "Aktiv",
        "form.account.permissions": "Berechtigungen",
        "form.account.permissions.read": "Lesen",
        "form.account.permissions.write": "Schreiben",
        "form.account.permissions.read_write": "Lesen und Schreiben",
        "form.account.permissions.plc": "",

        /* Location lexicons */

        "locations": "Niederlassungen",
        "locations.title": "Niederlassungen",
        "location": "Niederlassung",
        "location.view.title": "Niederlassung",
        "location.create.title": "Neue Niederlassung anlegen",
        "location.create.success": "Niederlassung erfolgreich erstellt.",
        "location.update.title": "Niederlassung bearbeiten",
        "location.update.success": "Niederlassung erfolgreich aktualisiert.",
        "location.active.title": "Möchten Sie diese Niederlassung wirklich aktivieren?",
        "location.active.success": "Niederlassung erfolgreich aktiviert.",
        "location.deactive.title": "Möchten Sie diese Niederlassung wirklich deaktivieren?",
        "location.deactive.success": "Niederlassung erfolgreich deaktiviert.",
        "location.risk.risk_number": "Risiko-Nr.",
        "location.risk.decided_budget": "Entschiedenes Limit",
        "location.risk.decided_budget.not_exist": "Kein Limit hinterlegt",
        "location.risk.valid_from": "Gültig ab",
        "location.risk.valid_until": "Gültig bis",
        "location.risk.limit": "Limit",
        "location.risk.not_valid": "Das Limit ist nicht mehr gültig",
        "location.risk.no_risk_number": "Niederlassung hat keine Risiko-Nr.",
        "location.risk.some.locations.without.risk": "Einige Niederlassungen haben keine Risiko-Nr.",
        "location.risk.some.locations.without.budget": "Einige Niederlassungen haben keine Budget Hinterlegt",

        /* Project managers lexicons */

        "pms": "Bauleiter",
        "pms.title": "Bauleiter",
        "pm": "Bauleiter",
        "pm.view.title": "Bauleiter",
        "pm.create.title": "Neuen Bauleiter anlegen",
        "pm.create.success": "Bauleiter erfolgreich erstellt.",
        "pm.update.title": "Bauleiter bearbeiten",
        "pm.update.success": "Bauleiter erfolgreich aktualisiert.",
        "pm.active.title": "Möchten Sie diesen Bauleiter wirklich aktivieren?",
        "pm.active.success": "Bauleiter erfolgreich aktiviert.",
        "pm.deactive.title": "Möchten Sie diesen Bauleiter wirklich deaktivieren?",
        "pm.deactive.success": "Bauleiter erfolgreich deaktiviert.",

        /* Customer admins lexicons */

        "admins": "Kundenadmins",
        "admins.title": "Kundenadmins",
        "admin": "Kundenadmin",
        "admin.view.title": "Kundenadmin",
        "admin.create.title": "Neuen Kundenadmin anlegen",
        "admin.create.success": "Kundenadmin erfolgreich erstellt.",
        "admin.update.title": "Kundenadmin bearbeiten",
        "admin.update.success": "Kundenadmin erfolgreich aktualisiert.",
        "admin.active.title": "Möchten Sie diesen Kundenadmin wirklich aktivieren?",
        "admin.active.success": "Kundenadmin erfolgreich aktiviert.",
        "admin.deactive.title": "Möchten Sie diesen Kundenadmin wirklich deaktivieren?",
        "admin.deactive.success": "Kundenadmin erfolgreich deaktiviert.",

        /* Customers lexicons */

        "customers": "Kunden",
        "customers.title": "Alle Kunden",
        "customers.list": "Kundenliste",
        "customers.search_customer": "Kundensuche",
        "customers.create": "Neukunde anlegen",
        "customers.update": "Kunde bearbeiten",
        "customers.list.empty": "Keine Kunden gefunden",
        "customers.overview": "Übersicht",
        "customers.projects_open": "offene Aufträge",
        "customers.projects_partly_done": "Aufträge teilerledigt",
        "customers.info": "Stammdaten",
        "customers.client_number": "Kundennummer",
        "customers.location_number": "Niederlassungs-Nr.",
        "customers.location_number.plc": "",
        "customers.project_number": "Projektnummer",
        "customers.project_number_required": "Projekt- oder Kostenstellennummer erforderlich",
        "customers.company_name": "Firmenname",
        "customers.contact_person": "Ansprechpartner",
        "customers.country": "Land",
        "customers.pm.mobile": "Mobil",
        "customers.hq_location": "Hauptsitz",

        "form.customers.save.success": "Der Kunde wurde erfolgreich gespeichert.",

        "form.customer.title.customer": "Kunde",
        "form.customer.title.hq_location": "Hauptsitz",

        "customer.customer.view.title": "Kunde",
        "customer.customer.create.title": "Neuen Kunde anlegen",
        "customer.customer.create.success": "Kunde erfolgreich erstellt.",
        "customer.customer.update.title": "Kunde bearbeiten",
        "customer.customer.update.success": "Kunde erfolgreich aktualisiert.",
        "customer.customer.active": "Möchten Sie diesen Kunde wirklich aktivieren?",
        "customer.customer.active.success": "Kunde erfolgreich aktiviert.",
        "customer.customer.deactive": "Möchten Sie diesen Kunde wirklich deaktivieren?",
        "customer.customer.deactive.success": "Kunde erfolgreich deaktiviert.",

        /* Exceptions */

        "exceptions.uploads.file_already_exists": "Die Datei existiert bereits.",
        "exceptions.uploads.extension_not_allowed": "Dieser Dateityp ist nicht erlaubt.",
        "exceptions.uploads.file_too_big": "Diese Datei ist zu groß.",  // TODO show the max configured size to user!
        "exceptions.uploads.upload_failed": "Ein unbekannter Fehler ist aufgetreten.",

        /* Account Names */
        "account.admin ": "Admin",
        "account.pm": "Bauleiter",
        "account.clientadmin": "Kundenadmin",
        "account.client": "Kunde",

        /* Tours */
        "tours.name": "Tourplan",
        "tours.expecteddate": "Datum vorauss.:",
        "tours.title": "Tourplan Übersicht",
        "tours.create.title": "Tourplan erstellen",
        "tours.create.success": "Tourplan erfolgreich erstellt.",
        "tours.update.title": "Tourplan bearbeiten",
        "tours.duplicate.title": "Tourplan-Duplikat erstellen",
        "tours.update.success": "Tourplan erfolgreich aktualisiert.",
        'tours.message.delete': 'Wollen Sie wirklich diesen Tourplan löschen?',
        'tours.message.delete.success': 'Tourplan erfolgreich gelöscht.',
        'tours.error.nogeocode': 'Die Geokoordinaten können wir nicht aufrufen.',
        "tours.tournumber": "Tourplan-Nummer",
        "tours.kolonne": "Kolonne",
        "tours.from": "von",
        "tours.till": "bis",
        "tours.route.index": "Index",
        "tours.route.objecttype": "Standorttyp",
        "tours.select": "Auswählen",
        "tours.mixingplants": "Mischanlagen",
        "tours.companyname": "Firmenname",
        "tours.button.companysearch": "Unternehmen suchen",
        "tours.button.projectsearch": "Aufträge auswählen",
        "tours.button.delete.projectsearch": "Ergebnis löschen",
        "tours.button.addtourplan": "zur Route hinzufügen",
        "tours.button.optimizeroute": "Route Optimieren",
        "tours.button.searchform": "Suchmaske",
        "tours.button.searchform.open": "Öffnen",
        "tours.button.searchform.close": "Schließen",
        "tours.headline.companysearch": "Unternehmen suchen",
        "tours.headline.projectsearch": "Unternehmen -und Bauleiter Ergebnis",
        "tours.headline.projectresults": "Auftragsergebnis",
        "tours.company.add": "Unternehmen hinzufügen",
        "tours.qm.max.open": "Offene QM",
        "tours.button.open.projectsearch": "Einzelnen Auftrag hinzufügen",
        "tours.addproject": "Auftrag hinzufügen",
        "tours.error.hastour": "Dieser Auftrag ist schon mit einer Tour verbunden",
        "tours.error.hasmatch": "Dieser Auftrag steht schon in dem Suchergebnis",
        "tours.error.routeoptserver": "Diese Route löste einen Fehler des Routenoptimierungsdienstes aus.",
        "tours.objecttype.project": "Auftrag",
        "tours.create.status": "Bitte speichern Sie Ihre Eingabe. Sonst werden alle Einstellungen verloren gehen.",
        "tours.objecttype.mixingplant": "Mischanlage",
        "tours.startpoint": "Startpunkt",
        "tours.endpoint": "Endpunkt",
        "tours.map.startpoint.error": "Bitte geben Sie eine gültige Startpunkt-Adresse ein",
        "tours.map.endpoint.error": "Bitte geben Sie eine gültige Endpunkt-Adresse ein",
        "tours.route_is_not_optimized": "Ihre Route ist noch nicht optimiert.",
        "tours.pdf.generate_message": "PDF für \"%{tour_number}\" generieren",
        "tours.message.routelimitreached": "Sie haben die maximale Anzahl von Adressen erreicht",
        "tours.distance": "Entfernung vom Vorort",
        "tours.error.search.qm": "Bitte prüfen Sie Ihre Eingabe.",
        "tours.searchhistory.buttonlabel.live" : "Live-Ansicht einblenden",
        "tours.searchhistory.buttonlabel.history": "Suchhistorie einblenden",

        /* Weeks */
        'weeks.title': 'Wochenplaner',
        'weeks.update.title': 'Tagesplan bearbeiten',
        'weeks.create.title': 'Tagesplan erstellen',
        'weeks.projects': 'Aufträge',
        'weeks.project': 'Auftrag',
        'weeks.entries': 'Einträge',
        'weeks.entry': 'Eintrag',
        'weeks.project.number': 'Auftragsnummer',
        'weeks.project.company_name': 'Firma',
        'weeks.project.address': 'Auftragsadresse',   // TODO this is _not_ the company adress, right? Its the project location?
        'weeks.project.layers': 'Sorte',
        'weeks.project.thickness': 'Dicke',
        'weeks.project.qm': 'QM',
        'weeks.project.tons': 'Tonne',
        'weeks.project.openqm': 'Offene QM',
        'weeks.project.tok': 'TOK',
        'weeks.project.without_tok': 'Ohne TOK',
        'weeks.project.with_tok': 'Mit TOK',
        'weeks.project.deadline': 'Wunschtermin',
        'weeks.project.uploads': 'Anlagen',
        'weeks.project.print_uploads': 'Anlagen ausdrucken',
        'weeks.project.milling': 'Fräsen',
        'weeks.project.milling.comment': 'Hilti + Stromaggregat mitnehmen!!!',
        'weeks.project.is_date_fixed': 'Fix-Termin',
        'weeks.project.add': 'Auftrag hinzufügen',
        'weeks.project.crud.add': 'Auftrag zum Wochenplan hinzufügen',
        'weeks.current_week': 'Aktivierte Woche',
        'weeks.error.save': 'Wir konnten diesen Eintrag nicht speichern. Bitte prüfen Sie Ihre Eingabe.',
        'weeks.success.save': 'Ihre Änderungen sind gespeichert.',
        'weeks.error.delete': 'Wir konnten diesen Eintrag nicht löschen.',
        'weeks.message.delete': 'Wollen Sie diesen Eintrag wirklich löschen?',
        'weeks.message.entryexits.title': 'Auftrag bereits eingestellt',
        'weeks.warning.weekend': 'Dieser Tag liegt an einem Wochenende. Sie dürfen an einem Wochenende keine Einträge anlegen.',
        'weeks.warning.nomixingplant': 'Sie haben noch keine Mischanlage ausgewählt.',
        'weeks.warning.changesnotsaved': 'Sie haben Änderungen vorgenommen, die noch nicht gesichert sind. Wenn Sie zu einer anderen Seite navigieren, gehen diese Änderungen verloren.',
        'weeks.kolonne.settings.title': 'Kolonnen-Einstellung',
        'weeks.kolonne.edit': 'Kolonnen Bearbeiten',
        'weeks.kolonne.empty': 'Diese Woche beinhaltet keine Kolonnen. Bitte Kolonnen anlegen.',
        'weeks.parkinglot.title': 'Parkplatz',
        'weeks.parkinglot.empty': 'Hier können Sie Elemente durch Ziehen und Ablegen aus dem Kalender parken.',
        'weeks.pdf.desc': 'Bitte wählen Sie die Kolonne für die PDF-Erstellung aus.',
        'weeks.reschedule.error': 'Ihre Auswahl konnte nicht verschoben werden. Das Startdatum oder Enddatum ist am Wochenende.',
        'weeks.button.menuindex': 'Reihenfolge speichern und aktualisieren',
        'weeks.button.saveall': 'Alle Einträge speichern',
        'weeks.button.emptyselection': 'Auswahl entleeren',
        'weeks.sorting.duplicates': 'Sie haben doppelte Indexeinstellungen. Bitte korrigieren Sie Ihre Einstellungen. Andernfalls fehlen Einträge in der druckbaren PDF-Datei.',

        /* Project planning export */
        'weeks.projectplanningexport.title': 'Aufträge für Kolonnen 100, 200 u. 300.',
        'weeks.projectplanningexport.desc': 'Wählen Sie einen Montag aus, um die für diese Woche eingeplanten Aufträge je Kolonne als JSON-Datei herunterzuladen. Sie bekommen eine Woche vorher und die Woche nacher mitgeliefert.',
        'weeks.projectplanningexport.button': 'Aufträge Export',
        'weeks.projectplanningexport.history_button': '3-Jahres-Export',
        'weeks.projectplanningexport.history_success': '%{projects} Auftrag/Aufträge wurden exportiert.',
        'weeks.projectplanningexport.history_error': 'Der Export der letzten 3 Jahre konnte nicht erstellt werden.',
        'weeks.projectplanningexport.success': '%{kolonnen} Kolonne(n) mit insgesamt %{projects} Auftrag/Aufträgen wurden exportiert.',
        'weeks.projectplanningexport.error': 'Der Export konnte nicht erstellt werden. Bitte prüfen Sie, ob das ausgewählte Datum ein Montag ist.',
        'weeks.projectplanningexport.send_button': 'Vergangenheit Abfragen',
        'weeks.projectplanningexport.send_success': 'Der Export wurde erfolgreich an KI MVP gesendet.',
        'weeks.projectplanningexport.send_waiting': 'Die KI-Abfrage läuft seit %{seconds} Sekunden.',
        'weeks.projectplanningexport.send_error': 'Der Export konnte nicht an KI MVP gesendet werden.',
        'weeks.projectplanningexport.current_button': 'Aufträge zu planen Abfragen',
        'weeks.projectplanningexport.current_desc': 'Sendet alle offenen und in Arbeit befindlichen Aufträge an die KI und zeigt den vorgeschlagenen Plan. Unabhängig vom gewählten Datum.',
        'weeks.projectplanningexport.current_success': '%{projects} Auftrag/Aufträge (offen oder in Arbeit) wurden exportiert.',
        'weeks.projectplanningexport.current_error': 'Der Export des aktuellen Stands konnte nicht erstellt werden.',

        /* Project planning export - KI-Ergebnis route map */
        'weeks.projectplanningexport.map.title': 'KI-Ergebnis',
        'weeks.projectplanningexport.map.kolonne_label': 'Kolonne',
        'weeks.projectplanningexport.map.kolonne_on_map': 'auf der Karte',
        'weeks.projectplanningexport.map.legend_title': 'Legende für die Wochentage',
        'weeks.projectplanningexport.map.show_routes': 'Straßenroute anzeigen',
        'weeks.projectplanningexport.map.start_point': 'Start',
        'weeks.projectplanningexport.map.start_note': 'Startpunkt: %{address} (%{km} km bis zum 1. Stopp)',
        'weeks.projectplanningexport.map.route_source_label': 'Route auf der Karte',
        'weeks.projectplanningexport.map.route_ki': 'KI-Route',
        'weeks.projectplanningexport.map.route_original': 'Ursprüngliche Route',
        'weeks.projectplanningexport.map.no_stops': 'Für diese Kolonne und Woche sind keine Aufträge eingeplant.',
        'weeks.projectplanningexport.map.unplanned_title': 'Nicht geplante Aufträge',
        'weeks.projectplanningexport.map.unplanned_desc': 'Aufträge, die offen sind und noch nicht geplant wurden.',
        'weeks.projectplanningexport.map.unplanned_reason': 'Grund',
        'weeks.projectplanningexport.map.navigate_title': 'In Google Maps navigieren',
        'weeks.projectplanningexport.map.week_error': 'Die Route für diese Woche konnte nicht von KI MVP abgerufen werden.',
        'weeks.projectplanningexport.map.route_error': 'Die Straßenroute konnte nicht geladen werden.',
        'weeks.projectplanningexport.map.stops_title': 'KI generierte Wochenplan',
        'weeks.projectplanningexport.map.stops_desc': 'Die Nummer läuft über die angezeigte Woche.',
        'weeks.projectplanningexport.map.stops_number': 'Nr.',
        'weeks.projectplanningexport.map.stops_day': 'Tag',
        'weeks.projectplanningexport.map.stops_address': 'Adresse',
        'weeks.projectplanningexport.map.stops_leg_km': 'Km',
        'weeks.projectplanningexport.map.stops_projects': 'Aufträge',
        'weeks.projectplanningexport.map.stops_open_qm': 'Offene QM',
        'weeks.projectplanningexport.map.metrics_distance': 'Entfernung',
        'weeks.projectplanningexport.map.metrics_qm': 'QM',
        'weeks.projectplanningexport.map.complete_qm': 'Komplett QM',
        'weeks.projectplanningexport.map.complete_km': 'Komplett Km',
        'weeks.projectplanningexport.map.total_qm': 'Gesamtfläche',
        'weeks.projectplanningexport.map.total_km': 'Gesamtkilometer',
        'weeks.projectplanningexport.map.km_disclaimer': 'Wir verwenden Fluglinien zur Berechnung der Kilometer. Die tatsächlichen Kilometer können daher von den angezeigten Kilometern abweichen.',
        'weeks.projectplanningexport.map.original_title': 'Ursprünglicher Wochenplan',
        'weeks.projectplanningexport.map.original_desc': 'Reihenfolge der gespeicherten Wochenplaneinträge dieser Kolonne in der angezeigten Woche. Ein Eintrag über mehrere Tage erscheint an jedem dieser Tage.',
        'weeks.projectplanningexport.map.original_time': 'Zeit',
        'weeks.projectplanningexport.map.original_loading': 'Der Wochenplan wird geladen.',
        'weeks.projectplanningexport.map.original_empty': 'Für diese Kolonne und Woche sind keine Wochenplaneinträge gespeichert.',
        'weeks.projectplanningexport.map.original_error': 'Der gespeicherte Wochenplan konnte nicht geladen werden.',
        'weeks.projectplanningexport.map.original_distance_loading': '…',
        'weeks.projectplanningexport.map.original_distance_unavailable': 'nicht verfügbar',

        /* Project map */
        'projectmap.error.loading': 'Karte kann nicht geladen werden. Keine Aufträge zurückgegeben.',
        'projectmap.error.noresults': 'Keine Aufträge mit diesem Sortiment.',
        'projectmap.label.resetmap': 'Zurücksetzen',
        'projectmap.label.filterqm': 'QM Filter',
        'projectmap.label.filtersort': 'Asphaltsorte auswählen',

        /* Kolonne / Crew */
        'kolonne.title': 'Kolonne',
        'kolonne.create.title': 'Kolonne erstellen',
        'kolonne.update.title': 'Kolonne bearbeiten',
        'kolonne.number': 'Kolonnennummer',
        "kolonne.create.success": "Kolonne erfolgreich erstellt.",
        "kolonne.update.success": "Kolonne erfolgreich aktualisiert.",
        'kolonne.message.delete': 'Wollen Sie diese Kolonne wirklich löschen?',
        'kolonne.settings.duplicate.title': 'Kolonnen-Einstellung duplizieren',
        'kolonne.settings.duplicate.target': 'Ziel',
        'kolonne.settings.vehicles': 'Fahrzeuge',
        'kolonne.settings.duplicate.all.label': 'Alle Einstellungen in die nächste Woche übertragen',
        'kolonne.settings.duplicate.desc': 'Hier können Sie die obigen Kolonnen-Einstellung auf eine Zielkolonne und Datum duplizieren. Hinweis: Wenn die Kolonne-Einstellung bereits vorhanden ist, wird sie überschrieben.',

        /* Kolonne / Employees */
        'kolonne.employees': 'Mitarbeitende',
        'kolonne.employees.selected': 'Ausgewählte Mitarbeitende',
        'kolonne.employees.available': 'Auswählbare Mitarbeitende',
        'kolonne.employees.noemployees.selected': 'Noch keine Mitarbeitenden ausgewählt',
        'kolonne.employees.title.modal': 'Einstellungen für Kolonnenmitarbeitende',
        'kolonne.message.noemployees': 'Noch keine Mitarbeitenden angelegt',
        'kolonne.employees.source.geocapture.hint': 'Die Liste an Mitarbeitenden wird aus geoCapture geladen.',


        'kolonne.settings.comment': 'Hinweise',
        'kolonne.settings.notsaved': 'Kolonnen-Einstellungen müssen über den grünen "Speichern"-Button (rechts) gespeichert werden',

        'kolonne.employees.saveerror': 'Es trat ein Fehler beim Speichern der Mitarbeitenden auf',
        'kolonne.employees.refresherror': 'Es trat ein Fehler beim Aktualisieren der Mitarbeitenden auf. Bitte probieren Sie es in 1 Minute erneut',

        'kolonne.vehicle.saveerror': 'Es trat ein Fehler beim Speichern der Fahrzeugzuweisung auf',
        'kolonne.vehicle.refresherror': 'Es trat ein Fehler beim Aktualisieren der Fahrzeugen auf. Bitte probieren Sie es in 1 Minute erneut',

        'kolonne.settings.notactivated': 'Kolonnen-Einstellung noch nicht aktiviert',
        'kolonne.settings.data.refresh': 'Daten aktualisieren',
        'kolonne.settings.notavailable': 'ist nicht verfügbar',
        'kolonne.label.assigned.to.other.kolonnen': 'zugewiesen in Kolonnen:',

        /* Kolonne / Vehicles */
        'kolonne.vehicle.available': 'Auswählbare Fahrzeuge',
        'kolonne.vehicle.selected': 'Ausgewählte Fahrzeuge',
        'kolonne.vehicle.source.geocapture.hint': 'Die Liste an Fahrzeugen wird aus geoCapture geladen und automatisch einmal pro Tag aktualisiert. Bei Bedarf können die Daten manuell aktualisiert werden.',
        'kolonne.vehicle.novehicles.selected': 'Noch keine Fahrzeuge ausgewählt',

        'kolonne.vehicle.select.label': 'Fahrzeugtyp Auswählen',
        'kolonne.vehicle.title.addedvehicles': 'Angelegte Fahrzeuge',
        'kolonne.vehicle.title.modal': 'Einstellungen für Kolonnenfahrzeuge',
        'kolonne.vehicle.number': 'Kennzeichen',
        'kolonne.message.novehicles': 'Noch keine Fahrzeuge angelegt',
        'kolonne.error.nokolonne': 'Diese Kolonne existiert noch nicht. Bitte Kolonne anlegen.',

        /* Mixing plants */
        'mixingplants.title': 'Mischanlagen',
        'mixingplants.list.button.title': 'Mischwerke bearbeiten',
        'mixingplants.title.search': 'Mischanlagensuche',
        'mixingplants.ranking.label': 'Bewertung',
        "mixingplants.create.success": "Mischanlage erfolgreich erstellt.",
        "mixingplants.update.success": "Mischanlage erfolgreich aktualisiert.",
        "mixingplant.search.title": "Mischanlagesuche",
        "mixingplant.search.add": "Mischanlage hinzufügen",
        "mixingplant.search.error.no_address": "Keine Adresse für PLZ %{zipcode} gefunden\n",
        
        /* Internal area */
        "project.internal_note": "Notiz",
        "project.internalarea.title": "Interne Informationen zum Auftrag",
        
        /* Internal files */
        "internalfiles.button.export": "Dateien exportieren",
        "internalfiles.button.download": "Zip-Datei herunterladen",
        "internalfiles.dropfileshere": "Fügen Sie Dateien hier ab",
        "internalfiles.releasefileshere": "Dateien loslassen, um sie hier abzufügen",
        "internalfiles.clicktoupload": "Klicken Sie hier, um den Upload zu starten",
        "internalfiles.description": "Laden Sie bitte hier PDF-Dateien, .docx oder Bilddateien (jpg) zu Ihrem Teilauftrag hoch.<br/><strong>Bitte beachten Sie die max. Dateigröße von 10 MB!</strong>",
    }
};
